<template>
  <SysDialogFullscreen
    v-model="MODAL_ATIVO_COMPUTED"
    transition="dialog-bottom-transition"
    titulo="Configuração do Mix da Filial"
  >
    <div style="margin: 100px" class="d-flex">
      <div class="py-3 w-20-porcento" style="margin: 100px 60px 100px 100px">
        <h2 class="font-22 font-weight-medium">Download do Modelo de Mix</h2>
        <p class="font-16 text-gray-300 mt-2 py-4">
          Baixe o modelo a seguir para desenvolver seu Modelo de Mix de Filial. Salve-o como <b>.xlsx</b> e faça
          o
          upload clicando no botão de Upload de Modelo de Mix.
        </p>

        <v-btn
          color="#013254"
          class="vbtn-class pa-5"
          text
          @click="baixarModeloMix"
        >
          <v-icon class="mr-3">$DownloadSimple</v-icon>
          Download Modelo de Mix
        </v-btn>
      </div>

      <v-form class="w-80-porcento" ref="form1" v-model="valid.step1" lazy-validation>
        <WizardSteps
          :step="step"
          :irPara="irPara"
          :podeIr="podeIr"
          :erros_por_step="erros_por_step"
        />

        <v-sheet
          v-if="step === 1"
          class="dropzone cursor-pointer"
          :style="{ borderColor: erros_por_step['2'] === true ? '#E02244' : '#7C7C83' }"
          outlined
          rounded
          @click="$refs.fileInput.$refs.input.click()"
          @dragover.prevent
          @dragenter.prevent
          @drop.prevent="onDrop"
        >
          <div class="dz-content">
            <v-icon size="70" color="#28293D" class="mt-n6 mb-5">$CloudArrowUp</v-icon>

            <div v-if="files.length <= 0">
              <div class="dz-title">Escolha um arquivo ou arraste e solte-o aqui</div>
              <div class="dz-sub">Apenas arquivos .xlsx</div>

              <v-btn
                color="#013254"
                class="white--text text-none mt-5 bra-6"
                height="40"
                :loading="loading"
              >
                Selecionar Arquivo
              </v-btn>
            </div>

            <div v-if="files && files.length" class="dz-list">
              <div v-for="(f,i) in files" :key="i">
                <div class="dz-item">
                  <v-icon color="#000000" size="40" class="mr-2">$FileXls</v-icon>
                  <span style="color: #19191C; font-size: 20px">{{ f.name }}</span>

                  <v-btn icon class="ml-6" @click.stop="resetarFluxoUpload">
                    <v-icon color="#73787F" size="30">$XCircle</v-icon>
                  </v-btn>
                </div>

                <span class="ml-1 grey--text text--darken-1">{{ (f.size / 1024).toFixed(0) }} KB de 10 MB</span>
                <v-progress-linear
                  :value="reading_pct"
                  color="#0C75BE"
                  height="8"
                  class="mt-4 bra-8"
                />
              </div>
            </div>
          </div>

          <v-file-input
            ref="fileInput"
            v-model="files"
            class="d-none"
            :multiple="false"
            :accept="'text/csv, application/vnd.ms-excel, .xlsx, .xls'"
            :rules="[rules.required]"
            @change="onChosen"
          />
        </v-sheet>

        <v-sheet
          v-else-if="step === 2"
          class="dropzone cursor-pointer"
          :style="{ borderColor: erros_por_step['2'] === true ? '#E02244' : '#7C7C83' }"
          outlined
          rounded
          @click="$refs.fileInput.$refs.input.click()"
          @dragover.prevent
          @dragenter.prevent
          @drop.prevent="onDrop"
        >
          <div class="dz-content">
            <v-icon size="70" color="#28293D" class="mt-n6 mb-5">$CloudArrowUp</v-icon>

            <div v-if="files.length <= 0">
              <div class="dz-title">Escolha um arquivo ou arraste e solte-o aqui</div>
              <div class="dz-sub">Apenas arquivos .xlsx</div>

              <v-btn
                color="#013254"
                class="white--text text-none mt-5 bra-6"
                height="40"
                :loading="loading"
              >
                Selecionar Arquivo
              </v-btn>
            </div>

            <div v-if="files && files.length" class="dz-list">
              <div v-for="(f,i) in files" :key="i">
                <div class="dz-item">
                  <v-icon color="#000000" size="40" class="mr-2">$FileXls</v-icon>
                  <span style="color: #19191C; font-size: 20px">{{ f.name }}</span>

                  <v-btn icon class="ml-6" @click.stop="resetarFluxoUpload">
                    <v-icon color="#73787F" size="30">$XCircle</v-icon>
                  </v-btn>
                </div>

                <span class="ml-1 grey--text text--darken-1">{{ (f.size / 1024).toFixed(0) }} KB de 10 MB</span>
                <v-progress-linear
                  v-if="erros_por_step['2']"
                  :value="reading_pct"
                  color="#C0142F"
                  height="8"
                  class="mt-4 bra-8"
                />

                <v-progress-linear
                  v-else
                  color="#0CB97B"
                  :value="100"
                  height="8"
                  class="mt-4 bra-8"
                />

                <div class="wizard-error-mensagem">
                  {{ erros_mensagem }}
                </div>
              </div>
            </div>
          </div>

          <v-file-input
            ref="fileInput"
            v-model="files"
            class="d-none"
            :multiple="false"
            :accept="'text/csv, application/vnd.ms-excel, .xlsx, .xls'"
            :rules="[rules.required]"
            @change="onChosen"
          />
        </v-sheet>

        <v-sheet
          v-else
          class="dropzone-concluido"
          outlined
          rounded
        >
          <div class="dz-content">
            <v-icon size="70" color="#0CB97B" class="mt-n6 mb-5">$CheckCircle</v-icon>

            <div>
              <div class="dz-title">Arquivo importado com sucesso!</div>
              <div class="dz-sub">Todos os dados do arquivo inserido estão corretos.</div>

              <div v-for="(f,i) in files" :key="i" class="dz-item-concluido font-14 text-gray-400">
                <span>{{ f.name }}</span>

                <v-btn icon class="ml-4" @click.stop="resetarFluxoUpload">
                  <v-icon color="#73787F" size="30">$Trash</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-sheet>

        <div class="d-flex justify-end mt-n8 mr-15">
          <v-btn
            class="vbtn-class"
            width="226"
            height="50"
            :disabled="step === 1"
            outlined
            @click="voltar"
          >
            Voltar
          </v-btn>

          <v-btn
            color="#013254"
            class="white--text"
            width="226"
            height="50"
            :disabled="step < 3"
            :loading="loading"
            @click="salvar"
          >
            Salvar
          </v-btn>
        </div>
      </v-form>
    </div>
  </SysDialogFullscreen>
</template>

<script>
import TabelaExemploUpload from "@/components/MixProdutosFilial/componentes/TabelaExemploUpload.vue";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import WizardSteps from "@/components/MixProdutosFilial/componentes/WizardSteps.vue";
import $axios from "@/api/api";
import api from "@/api/api";
import * as XLSX from "xlsx";

export default {
  name: 'DialogUploadModeloMix',
  components: { WizardSteps, SysDialogFullscreen, TabelaExemploUpload },
  props: { value: { type: Boolean, required: true } },
  data() {
    return {
      step: 1,
      loading: false,
      valid: { step1: false, step2: false, step3: false },
      form: { arquivo: null },
      rules: { required: v => !!v || 'Campo obrigatório' },
      files: [],
      linhas: [],
      reading_pct: 0,
      erros_mensagem: null,
      leitura_arquivo_timeout: null,
      validar_arquivo_timeout: null,
      etapa_dois_timeout: null,
      etapa_tres_timeout: null,
      erros_por_step: {
        1: false,
        2: false,
        3: false
      }
    }
  },
  methods: {
    baixarModeloMix() {
      window.open(`${$axios.defaults.baseURL}/mix-produtos-filial/download-modelo-mix`, "_blank");
    },
    fechar() {
      this.$emit('input', false);
    },
    voltar() {
      if (this.step === 2) this.resetarFluxoUpload();
      if (this.step > 1) this.step -= 1;
    },
    podeIr(n) {
      return this.step >= n;
    },
    irPara(n) {
      if (n === 3 || n === 1) {
        this.loading = false;
      }

      this.step = n;
    },
    onDrop(e) {
      this.loading = true;

      const dropped = Array.from(e.dataTransfer.files || []);
      if (!dropped.length) return;

      const file = dropped[0];
      this.files = [file];
      this.lerArquivo(file);
    },
    async onChosen(val) {
      this.loading = true;

      if (!val) return;
      const file = Array.isArray(val) ? val[0] : val;

      this.files = [file];
      this.lerArquivo(file);
    },
    lerArquivo(file) {
      this.reading_pct = 0;

      const reader = new FileReader();

      reader.onprogress = (ev) => {
        if (ev.lengthComputable) {
          this.reading_pct = 15;
        }
      };

      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        this.linhas = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        this.reading_pct = 30;
      };

      reader.onerror = () => {
        alert('Falha ao ler o arquivo local.');
      };

      reader.readAsArrayBuffer(file);
      this.validar_arquivo_timeout = setTimeout(this.validarArquivo, 1000);
      this.etapa_dois_timeout = setTimeout(() => this.irPara(2), 3000);
    },
    validarArquivo() {
      const headerEsperado = ["filial", "sku", "pertence_ao_mix", "movimentacao", "filial_origem"];
      const headerArquivo = this.linhas[0].map(h => String(h).toLowerCase().trim());
      const headerValido = headerEsperado.every((col, i) => headerArquivo[i] === col);

      for (let i = 0; i < this.files.length; i++) {
        const tipos_permitidos = ['xlsx', 'xls', 'csv'];
        const tipo_arquivo = this.files[i].name.split('.').pop();

        const tamanho_arquivo_em_mb = this.files[i].size / 1024;
        const limite = 10000;

        if (!tipos_permitidos.includes(tipo_arquivo)) {
          this.erros_por_step['2'] = true;
          this.erros_mensagem = "Tipo de arquivo inválido. Envie um arquivo no formato '.xlsx'.";

          this.loading = false;
          return false;
        }

        if (tamanho_arquivo_em_mb >= limite) {
          this.erros_por_step['2'] = true;
          this.erros_mensagem = "O tamanho do arquivo excede os 10 MB.";

          this.loading = false;
          return false;
        }
      }

      if (!headerValido) {
        this.erros_por_step['2'] = true;
        this.erros_mensagem = "Corrija os cabeçalhos da tabela enviada segundo o modelo.";

        this.loading = false;
        return false;
      }

      const valoresPermitidos = {
        pertence_ao_mix: ["SIM", "NAO", "NÃO", 'S', 'N'],
        movimentacao: ["PROPRIA", 'P', "MISTA", 'M', "RETIRA", 'R']
      };

      let erros = [];

      for (let i = 1; i < this.linhas.length; i++) {
        const linha = this.linhas[i];

        if (linha.length <= 0) continue;

        const pertenceAoMix = (linha[2] || "").toString().trim().toUpperCase();
        const movimentacao = (linha[3] || "").toString().trim().toUpperCase();

        if (!valoresPermitidos.pertence_ao_mix.includes(pertenceAoMix)) {
          erros.push(`Linha ${i + 1}: valor inválido em pertence_ao_mix -> "${linha[2]}"`);
        }
        if (!valoresPermitidos.movimentacao.includes(movimentacao)) {
          erros.push(`Linha ${i + 1}: valor inválido em movimentacao -> "${linha[3]}"`);
        }
      }

      if (erros.length > 0) {
        this.erros_por_step['2'] = true;
        this.erros_mensagem = `Corrija as ${erros.length - 1} linhas da tabela com erros e faça o upload novamente.`;

        this.loading = false;
        return false;
      }

      this.etapa_tres_timeout = setTimeout(() => this.irPara(3), 3000);
      return true;
    },
    resetarFluxoUpload() {
      clearTimeout(this.etapa_dois_timeout);
      clearTimeout(this.etapa_tres_timeout);
      clearTimeout(this.leitura_arquivo_timeout);
      clearTimeout(this.validar_arquivo_timeout);

      this.files = [];
      this.reading_pct = 0;
      this.erros_mensagem = null;
      this.erros_por_step = {
        1: false,
        2: false,
        3: false
      };

      this.irPara(1);
    },
    salvar() {
      this.MODAL_ATIVO_COMPUTED = false;

      const f = Array.isArray(this.files) ? this.files[0] : this.files;
      if (!f) return;

      const form = new FormData();
      form.append('modelo_mix', f);

      api.post('/mix-produtos-filial/upload-modelo-mix', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setTimeout(this.resetarFluxoUpload, 1000);
      setTimeout(() => this.$emit('upload:concluido'), 1000);
    },
  },
  computed: {
    MODAL_ATIVO_COMPUTED: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
}
</script>

<style scoped>
.wizard-error-mensagem {
  margin-top: 14px;
  font-size: 16px;
  color: #E02244;
}

.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 10px 25px 10px 20px;
  border-radius: 6px;
  margin-top: 1px;
  margin-right: 15px;
  font-weight: 500;
}

.dropzone {
  height: 325px;
  margin: 38px;
  border-style: dashed;
  border-width: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.dropzone-concluido {
  height: 325px;
  margin: 38px;
  border: 2px dashed #0CB97B;
  background-color: #CEF7E866;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.dz-content {
  text-align: center;
}

.dz-title {
  font-weight: 500;
  color: #013254;
  font-size: 16px;
  margin-bottom: 4px
}

.dz-sub {
  font-size: 13px;
  color: #19191C;
}

.dz-list {
  margin-top: 16px;
  max-height: 80px;
  text-align: left
}

.dz-item {
  display: flex;
  align-items: center;
  margin-top: 6px
}

.dz-item-concluido {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-left: 45px;
}
</style>
